<template>
  <div class="card br-16 p-x3 w-50p" style="box-shadow: 0 2px 8px rgba(0,0,0, 0.10)">
    <div class="t-xl m-bx3 fc-ac bold">Building your Journey with AI</div>
    <div class="t-sm m-bx2 fc-ac">This might take a few minutes.</div>
    <div
      v-for="(item, idx) in loadingItems"
      :key="`loading-item-${idx}`"
      :class="`f-h f-ac ${idx > 0 ? 'm-tx2' : ''}`"
    >
      <lucide-icon v-if="item.status === 'done'" name="CircleCheckBig" class="green" :size="24" />
      <lucide-icon v-else-if="item.status === 'in_progress'" name="LoaderCircle" class="gray anim-spin" :size="24" />
      <lucide-icon v-else name="Circle" class="gray" :size="24" />
      <div class="t bold m-lx2">{{ item.text }}</div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const loadingItems = computed(() => {
    const res = [
      // Start state is submitted_goals, but it's not in this list since it doesn't have a bullet point of its own.
      {
        progress: ['extracting_information'],
        text: 'Reviewing any uploaded documents',
      },
      {
        progress: ['extracted_information'],
        text: 'Processing goals',
      },
      {
        progress: ['planned_event_groups', 'creating_event_groups'],
        text: 'Planning Journey',
      },
      {
        progress: ['requires_user_info_for_events', 'creating_journey_records'],
        text: 'Writing messages',
      },
      {
        progress: ['completed'],
        text: 'Finalizing Journey',
      },
    ];
    const currentProg = res.map(i => i.progress).findIndex(p => p.includes(state.journeyBuilderWorkflow.progress)); // -1 if initial state (submitted_goals).
    res.forEach((item, idx) => {
      if (currentProg === idx - 1) {
        item.status = 'in_progress';
      } else if (currentProg < idx - 1) {
        item.status = 'pending';
      } else {
        item.status = 'done';
      }
    });
    return res;
  });
</script>
